import {RouteRecordRaw} from 'vue-router';

export const balanceRoutes: RouteRecordRaw = {
  path: 'balance',
  name: 'Balance',
  meta: {requiresAuth: true, feature: 'billing'},
  children: [
    {
      path: 'in_favor',
      name: 'InFavor',
      meta: {requiresAuth: true},
      component: () => import('@/features/billing/views/inFavor/InFavor.vue'),
    },
    {
      path: 'against',
      name: 'Against',
      meta: {requiresAuth: true},
      component: () => import('@/features/billing/views/against/Against.vue'),
    },
  ],
};

export const systemRoutes: RouteRecordRaw = {
  path: 'system',
  name: 'System',
  meta: {requiresAuth: true},
  component: () => import('@/features/dashboard/views/Soon.vue'),
  children: [
    {
      path: 'modules',
      name: 'Modules',
      meta: {requiresAuth: true},
      component: () => import('@/features/dashboard/views/Soon.vue'),
    },
  ],
};

export const reportsRoutes: RouteRecordRaw = {
  path: 'reports',
  name: 'HomeReports',
  meta: {requiresAuth: true, feature: 'reports'},
  children: [
    {
      path: '',
      name: 'Reports',
      meta: {requiresAuth: true},
      component: () => import('@/features/dashboard/views/Soon.vue'),
    },
  ],
};

export const supportRoutes: RouteRecordRaw = {
  path: 'support',
  name: 'Support',
  meta: {requiresAuth: true},
  component: () => import('@/features/dashboard/views/Soon.vue'),
};

export const plansRoutes: RouteRecordRaw = {
  path: 'plans',
  name: 'Plans',
  meta: {requiresAuth: true},
  component: () => import('@/features/dashboard/views/Soon.vue'),
};

export const globalAppointmentRoutes: RouteRecordRaw = {
  path: 'appointments',
  name: 'GlobalAppointment',
  meta: {requiresAuth: true, feature: 'appointments'},
  component: () => import('@/features/appointments/views/Appointment.vue'),
};

export const visitsRoutes: RouteRecordRaw = {
  path: 'visits',
  name: 'Visits',
  meta: {requiresAuth: true},
  children: [
    {
      path: ':ownerID?/:petID?',
      name: 'NewVisit',
      meta: {requiresAuth: true},
      component: () => import('@/features/visits/views/NewVisit.vue'),
      props: (route) => ({
        ownerID: route.params.ownerID || '',
        petID: route.params.petID || '',
      }),
    },
  ],
};
